import React, { useState, useEffect } from "react";
import Utils from "../utils/utils";
import { getApiUrl } from "../utils/apiConfig";

const UserProfile = () => {
    // Get user data from localStorage instead of router state
    const [user, setUser] = useState(null);
    const [userEvents, setUserEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    
    // Load user data from localStorage on component mount
    useEffect(() => {
        const storedUser = localStorage.getItem('selectedUser');
        if (storedUser) {
            const parsedUser = JSON.parse(storedUser);
            setUser(parsedUser);
            setLoading(false);
        } else {
            console.error('No user data found in localStorage');
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (user) {
            getUserEvents();
        }
    }, [user]); // Only fetch events when user data is available

    const getUserEvents = async () => {
        if (!user) return;
        
        try {
            const response = await fetch(getApiUrl("/users/getUserEvents"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ mail: user.userEmail }),
            });
            const data = await response.json();
            console.log(data);
            setUserEvents(data);
        } catch (error) {
            console.error("Error fetching user events:", error);
        }
    };

    if (loading) {
        return (
            <div className="flex w-full h-full p-2 justify-center items-center">
                <div className="border-4 w-8 h-8 border-blue-500 border-dotted rounded-full animate-spin"></div>
                <p className="text-blue-500 ml-2">Loading user data...</p>
            </div>
        );
    }

    if (!user) {
        return (
            <div className="flex w-full h-full p-2 justify-center items-center">
                <p className="text-red-500">No user data available. Please select a user from the users list.</p>
            </div>
        );
    }

    return (
        <div className="flex w-full h-full p-2">
            <div className="w-[300px] break-all flex flex-col py-4 pl-4 items-start justify-start h-full bg-gray-200 gap-2">
                <div className="text-md font-bold">Name: {user.userName}</div>
                <div className="text-sm">Email: {user.userEmail}</div>
                <div className="text-sm">Role: {user.userRole}</div>
            </div>
            <div className="pl-1 items-start w-full h-full overflow-scroll relative">
                <div className="flex flex-col items-start w-full h-full overflow-scroll">
                    {userEvents.length > 0 ? (
                        userEvents.map((eventObject, index) => (
                            <EventDetailsCard eventObject={eventObject} key={index} index={index} />
                        ))
                    ) : (
                        <p className="p-4">No events found for this user.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UserProfile;

const EventDetailsCard = ({ eventObject, index }) => {
    const [selectedEvent, setSelectedEvent] = useState(null);

    const handleEventClick = (event) => {
        setSelectedEvent(!selectedEvent ? event : null);
    };

    const formatedEventObject = (eventObject) => {
        let keys = Object.keys(eventObject);
        let str = "";
        keys.forEach((key) => {
            str += `<span className="font-semibold">${key} : </span>  <span className="pl-2">${eventObject[key]}</span> <br/>`;
        });
        return str;
    };

    return (
        <div className="p-2 flex flex-col justify-start border-b border-gray-300 w-full">
            <button className="p-2 flex flex-col rounded-md text-left font-bold" key={index} onClick={() => handleEventClick(eventObject)}>
                {eventObject.event}
                <span className="text-[12px] text-gray-500">{`${Utils.getDateTime(eventObject.createdon)}`}</span>
            </button>
            {selectedEvent && <div className="p-2 ml-10 rounded-md text-left" dangerouslySetInnerHTML={{ __html: formatedEventObject(selectedEvent) }}></div>}
        </div>
    );
};
